import { render, staticRenderFns } from "./UiFocusContainer.vue?vue&type=template&id=f24c9cbc"
import script from "./UiFocusContainer.vue?vue&type=script&lang=js"
export * from "./UiFocusContainer.vue?vue&type=script&lang=js"
import style0 from "./UiFocusContainer.vue?vue&type=style&index=0&id=f24c9cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports